document.addEventListener('wpcf7mailsent', function (event) {
    gtag('event', 'generate_lead', { 'event_category': 'formularz', 'event_label': 'wyslij' })
});

const phones = document.querySelectorAll('a[data-type="tel"]');
phones.forEach((phone) => {
    phone.addEventListener('click', () => {
        gtag('event', 'generate_lead', { 'event_category': 'telefon', 'event_label': 'klik' })
    });
});